import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DocumentCopyIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 19 19"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M10.9393 3.54286C11.1383 3.54286 11.329 3.62413 11.4697 3.7688L14.7803 7.17405C14.921 7.31872 15 7.51494 15 7.71954V16.6571C15 17.0832 14.6642 17.4286 14.25 17.4286H5.25C4.83579 17.4286 4.5 17.0832 4.5 16.6571V4.31429C4.5 3.88824 4.83579 3.54286 5.25 3.54286H10.9393ZM10.5 4.31429H5.25V16.6571H14.25V8.17143H11.25C10.8358 8.17143 10.5 7.82605 10.5 7.4V4.31429ZM10.125 2C10.3321 2 10.5 2.17269 10.5 2.38571C10.5 2.59874 10.3321 2.77143 10.125 2.77143H3.75V14.7286C3.75 14.9416 3.58211 15.1143 3.375 15.1143C3.16789 15.1143 3 14.9416 3 14.7286V2.77143C3 2.34538 3.33579 2 3.75 2H10.125ZM10.875 13.5714C11.0821 13.5714 11.25 13.7441 11.25 13.9571C11.25 14.1702 11.0821 14.3429 10.875 14.3429H7.125C6.91789 14.3429 6.75 14.1702 6.75 13.9571C6.75 13.7441 6.91789 13.5714 7.125 13.5714H10.875ZM12.375 11.6429C12.5821 11.6429 12.75 11.8155 12.75 12.0286C12.75 12.2416 12.5821 12.4143 12.375 12.4143H7.125C6.91789 12.4143 6.75 12.2416 6.75 12.0286C6.75 11.8155 6.91789 11.6429 7.125 11.6429H12.375ZM12.375 9.71429C12.5821 9.71429 12.75 9.88698 12.75 10.1C12.75 10.313 12.5821 10.4857 12.375 10.4857H7.125C6.91789 10.4857 6.75 10.313 6.75 10.1C6.75 9.88698 6.91789 9.71429 7.125 9.71429H12.375ZM11.25 4.63443V7.4H13.9395L11.25 4.63443Z"
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);

DocumentCopyIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DocumentCopyIcon);
